import { useState, useEffect, useRef } from 'react';
import { serialize, deserialize, update } from 'serializr';

import { deepObserve } from 'mobx-utils';

import set from 'lodash/set';
import get from 'lodash/get';

// TODO modify to serialize entire object when editing

export default function useViewModel<T>(obj: T): [T, Partial<T>] {
    const [patch, setPatch] = useState({});
    const [newObj, setNewObj] = useState(deserialize(obj, serialize(obj)));
    const rendered = useRef(false);

    useEffect(() => {
        return deepObserve(newObj, (change, path) => {
            const { type } = change;

            switch (type) {
                case 'update':
                    if (Array.isArray(change.object)) {
                        set(patch, path.split('/'), serialize(change.object));
                        // set(patch, [...path.split('/'), change.index], change.newValue);
                    } else {
                        const pathComponents = path === '' ? [] : path.split('/');

                        if (get(obj, [...pathComponents, change.name]) === change.newValue) {
                            if (pathComponents.length) {
                                delete get(patch, pathComponents)[change.name];
                            } else {
                                delete patch[change.name];
                            }
                        } else {
                            if (change.newValue?.constructor?.serializeInfo) {
                                // FIXME: This won't set any unset fields on the patch
                                set(
                                    patch,
                                    [...pathComponents, change.name],
                                    serialize(change.newValue)
                                );
                            } else {
                                set(patch, [...pathComponents, change.name], change.newValue);
                            }
                        }
                    }

                    break;
                case 'splice':
                    const { added, removed } = change;

                    break;
            }
        });
    }, [patch, newObj]);

    useEffect(() => {
        if (rendered.current) {
            setPatch({});
            setNewObj(deserialize(obj, serialize(obj)));
        }
        rendered.current = true;
    }, [obj]);

    newObj.submit = () => {
        update(obj, patch);
    };

    newObj.reset = () => {
        setPatch({});
        setNewObj(deserialize(obj, serialize(obj)));
    };

    newObj.isDirty = () => {
        return Object.keys(patch).length !== 0;
    };

    return [newObj, patch];
}
